import { ResetPasswordForm } from "../../organisms/form/ResetPasswordForm";
import { CardTemplate } from "../../templates/CardTemplate";
import { usePasswordUpdate } from "./hook";

export const ResetPasswordPage: React.FC = () => {
  const { handleUpdatePassword } = usePasswordUpdate();

  return (
    <CardTemplate title="パスワード再設定">
      <ResetPasswordForm
        handleSubmit={handleUpdatePassword}
      ></ResetPasswordForm>
    </CardTemplate>
  );
};
